// drawer/components/MitreWeaknessesComponent.tsx
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router';

import { Table } from '@/components/table/Table';
import { Section } from '@/sections/threats/components';
import type { EnrichedVulnerability, Weakness } from '@/sections/threats/types';

interface MitreWeaknessesComponentProps {
  threatIntel?: EnrichedVulnerability;
}

/**
 * MITRE CWE weaknesses table component
 */
export function MitreWeaknessesComponent({
  threatIntel,
}: MitreWeaknessesComponentProps) {
  const { weaknesses = [] } = threatIntel ?? {};

  return (
    <Section title="MITRE CWE Weaknesses">
      {weaknesses.length === 0 && (
        <p className="text-sm">No known information at this time</p>
      )}
      {weaknesses.length > 0 && (
        <Table<Weakness>
          name="MITRE CWE Weaknesses"
          status="success"
          columns={[
            { label: 'Weakness ID', id: 'value', fixedWidth: 150 },
            { label: 'Name', id: 'name' },
            { label: 'Type', id: 'type', fixedWidth: 100 },
            { label: 'Source', id: 'source' },
            {
              label: '',
              id: 'url',
              fixedWidth: 40,
              onClick: item => {
                window.open(item.url, '_blank');
              },
              cell: item => (
                <Link
                  to={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-chariot-brand-primary"
                >
                  <div>
                    <ArrowTopRightOnSquareIcon className="size-4" />
                  </div>
                </Link>
              ),
            },
          ]}
          data={weaknesses}
          error={null}
          selection={{ hide: true }}
        />
      )}
    </Section>
  );
}
